import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Quote, Star } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { testimonials } from '../mockData';
import usePageMeta from '../hooks/usePageMeta';

const Reviews = () => {
  usePageMeta({
    title: 'Reviews & Testimonials | Shore Doors Locksmiths',
    description:
      "What Auckland's security companies, consultants and clients say about Shore Doors Locksmiths — reliability, quality installs and easy people to work with.",
  });

  return (
    <div className="min-h-screen">
      <section className="relative bg-gray-950 py-16 sm:py-20 text-white overflow-hidden">
        <div className="absolute inset-0" aria-hidden="true">
          <img src="/images/projects/papakura-library.webp" alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-gray-950 from-25% via-gray-950/75 via-55% to-gray-950/5"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl sm:text-5xl font-bold mb-5">What the professionals say</h1>
          <p className="text-xl text-gray-300 max-w-3xl">
            When security companies choose their install partner, reputation is everything.
            Here's ours — on the record.
          </p>
        </div>
      </section>

      <section className="py-16 sm:py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-6">
            {testimonials.map((t) => (
              <Card key={t.id} className="border-gray-200">
                <CardContent className="p-8">
                  <div className={`${t.logoBgDark ? 'bg-gray-800 border-gray-700' : 'bg-gray-50 border-gray-200'} border rounded-lg px-5 py-3 inline-flex items-center justify-center mb-5`} style={{ minWidth: '170px', height: '72px' }}>
                    <img src={t.logo} alt={`${t.company} logo`} className="max-h-12 w-auto object-contain" style={{ maxWidth: '150px' }} />
                  </div>
                  <Quote className="text-blue-200 mb-2" size={26} />
                  <blockquote className="text-gray-700 leading-relaxed mb-4 italic">"{t.quote}"</blockquote>
                  <div className="border-t border-gray-100 pt-4">
                    <p className="font-semibold text-gray-900">{t.name}</p>
                    <p className="text-gray-500 text-sm">{t.title}</p>
                    <p className="text-blue-600 text-sm font-medium">
                      {t.website ? (
                        <a href={t.website} target="_blank" rel="noopener noreferrer" className="hover:underline">{t.company}</a>
                      ) : (
                        t.company
                      )}
                    </p>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Google reviews slot — populate once the GBP has reviews (plan §7) */}
          <Card className="border-dashed border-2 border-gray-200 mt-10 bg-gray-50">
            <CardContent className="p-8 text-center">
              <div className="flex justify-center gap-1 mb-3">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={20} className="text-amber-400 fill-amber-400" />
                ))}
              </div>
              <p className="text-gray-700 font-medium mb-1">Google reviews coming</p>
              <p className="text-gray-500 text-sm max-w-xl mx-auto">
                We've just opened our doors to homes and businesses directly — reviews from those
                jobs will appear here as they come in.
              </p>
            </CardContent>
          </Card>

          <div className="text-center mt-12">
            <Link to="/contact">
              <Button size="lg" className="bg-blue-600 hover:bg-blue-700 text-white font-semibold">
                Work with us
                <ArrowRight className="ml-2" size={20} />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Reviews;
